"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const PartyName_1 = require("@/common/turmoil/PartyName");
const GameSetupDetail_vue_1 = require("@/client/components/GameSetupDetail.vue");
const GlobalParameterValue_vue_1 = require("@/client/components/GlobalParameterValue.vue");
const MoonGlobalParameterValue_vue_1 = require("@/client/components/moon/MoonGlobalParameterValue.vue");
const GlobalParameter_1 = require("@/common/GlobalParameter");
const PreferencesIcon_vue_1 = require("@/client/components/PreferencesIcon.vue");
const LanguageIcon_vue_1 = require("@/client/components/LanguageIcon.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'sidebar',
    props: {
        playerNumber: {
            type: Number,
            required: true,
        },
        gameOptions: {
            type: Object,
            required: true,
        },
        acting_player: {
            type: Boolean,
        },
        player_color: {
            type: String,
            required: true,
        },
        generation: {
            type: Number,
            required: true,
        },
        coloniesCount: {
            type: Number,
            required: true,
        },
        temperature: {
            type: Number,
            required: true,
        },
        oxygen: {
            type: Number,
            required: true,
        },
        oceans: {
            type: Number,
            required: true,
        },
        venus: {
            type: Number,
            required: true,
        },
        moonData: {
            type: Object,
        },
        turmoil: {
            type: Object,
        },
        lastSoloGeneration: {
            type: Number,
            required: true,
        },
        deckSize: {
            type: Number,
            required: true,
        },
        discardPileSize: {
            type: Number,
            required: true,
        },
    },
    components: {
        'game-setup-detail': GameSetupDetail_vue_1.default,
        'global-parameter-value': GlobalParameterValue_vue_1.default,
        MoonGlobalParameterValue: MoonGlobalParameterValue_vue_1.default,
        PreferencesIcon: PreferencesIcon_vue_1.default,
        LanguageIcon: LanguageIcon_vue_1.default,
    },
    data() {
        return {
            'ui': {
                'gamesetup_detail_open': false,
            },
            'globalParameter': GlobalParameter_1.GlobalParameter,
        };
    },
    methods: {
        getPlayerColorCubeClass() {
            return this.acting_player && ((0, PreferencesManager_1.getPreferences)().hide_animated_sidebar === false) ? 'preferences_player_inner active' : 'preferences_player_inner';
        },
        getSideBarClass() {
            return this.acting_player && ((0, PreferencesManager_1.getPreferences)().hide_animated_sidebar === false) ? 'preferences_acting_player' : 'preferences_nonacting_player';
        },
        getGenMarker() {
            return `${this.generation}`;
        },
        rulingPartyToCss() {
            if (this.turmoil?.ruling === undefined) {
                console.warn('no party provided');
                return '';
            }
            return this.turmoil.ruling.toLowerCase().split(' ').join('_');
        },
        getRulingParty() {
            const ruling = this.turmoil?.ruling;
            switch (ruling) {
                case PartyName_1.PartyName.MARS:
                    return 'Mars';
                case PartyName_1.PartyName.SCIENTISTS:
                    return 'Science';
                case PartyName_1.PartyName.KELVINISTS:
                    return 'Kelvin';
                case undefined:
                    return '???';
                default:
                    return ruling;
            }
        },
    },
    computed: {
        preferencesManager() {
            return PreferencesManager_1.PreferencesManager.INSTANCE;
        },
    },
});
